import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";

interface CertificateTableHeaderProps {
    children? : React.ReactNode
}

export const CertificateTableHeader = ({children} : CertificateTableHeaderProps ) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <thead className="sticky-top">
        <tr className="text-nowrap">
            <th className="th-w-min">{children}</th>
            <th>{t("certificate-table-header.email")}</th>
            <th>{t("certificate-table-header.subject")}</th>
            <th>{t("certificate-table-header.issuer")}</th>
            <th>{t("certificate-table-header.serial-number")}</th>
            <th>{t("certificate-table-header.thumbprint-sha512")}</th>
            <th>{t("certificate-table-header.thumbprint-sha1")}</th>
            <th>{t("certificate-table-header.not-before")}</th>
            <th>{t("certificate-table-header.not-after")}</th>
            <th>{t("certificate-table-header.key-usage")}</th>
            <th>{t("certificate-table-header.extended-key-usage")}</th>
            <th>{t("certificate-table-header.public-key-algorithm")}</th>
            <th>{t("certificate-table-header.public-key-length")}</th>
            <th>{t("certificate-table-header.signature-algorithm")}</th>
            <th>{t("certificate-table-header.validation-error")}</th>
         </tr>
        </thead>
    )
}
